import React from 'react';
import { FiLock, FiShield, FiFileText, FiDownload, FiShieldOff, FiInfo } from 'react-icons/fi';
import { SectionTitle } from '../shared/ModalHelpers';

const AnnexVaultCard = ({ anexos = [], handleDownload }) => (
    <div className="bg-[var(--bg-card)] p-8 rounded-[2.5rem] border border-[var(--border-color)] shadow-inner">
        <div className="flex justify-between items-center mb-8">
            <SectionTitle icon={FiLock} title="COFRE DE ANEXOS (DIPLOMACIA TÁTICA)" />
            <div className="flex items-center gap-2 text-emerald-500 bg-emerald-500/10 px-4 py-1.5 rounded-full border border-emerald-500/20">
                <FiShield size={12} />
                <span className="text-[10px] font-black uppercase tracking-widest">Túnel Master Ativo</span>
            </div>
        </div>

        {/* 🛰️ CARTÃO INFORMATIVO: CINZA ESCURO + LETRAS BRANCAS */}
        <div className="mb-8 p-6 bg-zinc-900 border border-white/10 rounded-[32px] flex items-center gap-5 shadow-2xl">
            <div className="p-3 bg-blue-600 rounded-2xl text-white shadow-lg">
                <FiInfo size={24} />
            </div>
            <div>
                <p className="text-white text-[13px] font-black uppercase tracking-widest leading-none">Protocolo de Extração Ghost</p>
                <p className="text-white/60 text-[10px] font-bold uppercase leading-tight mt-2 italic">
                    Documentos extraídos via stream binário local. Sem exposição de URLs ou diretórios Nginx.
                </p>
            </div>
        </div>

        {anexos.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                {anexos.map((doc, idx) => (
                    <div key={idx} className="p-5 bg-[var(--bg-main)] border border-[var(--border-color)] rounded-3xl group transition-all hover:border-[var(--accent-color)]">
                        <div className="flex items-center gap-4">
                            <div className="p-3 bg-[var(--text-primary)]/5 rounded-xl text-[var(--accent-color)] group-hover:bg-[var(--accent-color)] group-hover:text-white transition-all">
                                <FiFileText size={24} />
                            </div>
                            <div className="flex-1 truncate">
                                <p className="text-[9px] font-black opacity-40 uppercase mb-1">Dossiê Tipo</p>
                                <h5 className="text-xs font-black uppercase truncate leading-none">{doc.tipoDocumento}</h5>
                            </div>
                        </div>
                        <div className="mt-6">
                            <button 
                                onClick={() => handleDownload(doc.trackingID, doc.tipoDocumento)}
                                className="w-full flex items-center justify-center gap-3 py-3 bg-[var(--accent-color)] text-white rounded-xl text-[10px] font-black uppercase tracking-[0.2em] hover:opacity-90 active:scale-95 shadow-lg"
                            >
                                <FiDownload size={14} /> Extrair
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        ) : (
            <div className="flex flex-col items-center justify-center py-12 opacity-20">
                <FiShieldOff size={48} className="mb-4" />
                <span className="text-xs font-black uppercase tracking-[0.3em]">Cofre Vazio</span>
            </div>
        )}
    </div>
);

export default AnnexVaultCard;